<template>
    <div class="no-ui-slider" :class="singleSlider && 'single-slider'">
        <div v-if="labelText" class="no-ui-slider-label">{{ labelText }}</div>
        <div class="no-ui-slider-values">
            <div :id="id + '-value-min'" class="no-ui-slider-value-min"></div>
            <div v-if="!singleSlider" :id="id + '-value-max'" class="no-ui-slider-value-max"></div>
        </div>
        <div v-bind:id="id"></div>
    </div>
</template>

<script>
    import noUiSlider from 'nouislider';
    import wNumb from 'wnumb';

    export default {
        name: 'ui-slider',
        props: {
            id: String,
            formatSuffix: {
                type: String,
                default: ''
            },
            formatPrefix: {
                type: String,
                default: ''
            },
            minValue: {
                type: Number,
                default: 1
            },
            maxValue: {
                type: Number,
                default: 10
            },
            margin: {
                type: Number,
                default: 2
            },
            step: {
                type: Number,
                default: 1
            },
            labelText: { 
                type: String,
                default: undefined
            },
            singleSlider: {
                type: Boolean,
                default: false,
            },
            enableThousandSeperator: {
                type: Boolean,
                default: false,
            },
            initValue: {
                type: Array,
                default: undefined
            }
        },
        data() {
            return {
                config: {
                    margin: this.$props.margin,
                    step: this.$props.step,
                    start: [this.$props.minValue, this.$props.maxValue],
                    range: {
                        'min' : [this.$props.minValue],
                        'max': [this.$props.maxValue]
                    },
                    format: wNumb({
                        decimals: 0,
                        prefix: this.$props.formatPrefix,
                        suffix: this.$props.formatSuffix
                    })
                }
            }
        },
        mounted: function () {
            var vm = this

            if (vm.$props.enableThousandSeperator) {
                vm.config.format = wNumb({
                    decimals: 0,
                    thousand: '.',
                    prefix: this.$props.formatPrefix,
                    suffix: this.$props.formatSuffix
                });
            }

            //set predefined values
            if (vm.$props.singleSlider) {
                if (vm.$props.initValue !== undefined) {
                    vm.config.start = [this.$props.initValue[0]];
                    vm.sendSelectedValues(vm.config.start);
                } else {
                    vm.config.start = [this.$props.maxValue];
                }
            } else {
                if (vm.$props.initValue !== undefined) {
                    vm.config.start = [vm.$props.initValue[0], vm.$props.initValue[1]];
                    vm.sendSelectedValues(vm.config.start);
                }
            }

            let slider = document.getElementById(this.$props.id);
            var marginMin = document.getElementById(this.$props.id + '-value-min');
            var marginMax = document.getElementById(this.$props.id + '-value-max');

            noUiSlider.create(slider, vm.config);

            //event that triggers every time a handle is moved
            //'values' an array that contains all handle values.
            //'handle' is represent the index of the handle which value is being updated 
            slider.noUiSlider.on('update', function (values, handle) {
                if (handle) {
                    marginMax.innerHTML = values[handle];
                } else {
                    marginMin.innerHTML = values[handle];
                }
            });

            //event that triggers every time a handle is released
            //'unencoded' slider values without formatting
            slider.noUiSlider.on('end', function (values, handle, unencoded) {
                let roundedValues = unencoded.map(Math.round);
                vm.sendSelectedValues(roundedValues);
            });
        },
        methods: {
            sendSelectedValues: function (value) {
                this.$emit(`${this.id}`, value)
            }
        }
    }
</script>